import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DetailsPanel } from "@/components/common";
import { TraceLinkContent } from "@/components/traceLink/display";
import { TraceLinkButtons } from "@/components/traceLink/save";

/**
 * Displays trace link information.
 */
const __default__ = {
  name: "TraceLinkPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "displayTrace",
    "data-cy": "panel-trace-display"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TraceLinkButtons))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TraceLinkContent))
    ]),
    _: 1
  }))
}
}

})